import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import TodaysEvents from './TodaysEvents';
import TodaysMenu from './TodaysMenu';
import './DayOverview.css';

class DayOverview extends PureComponent {
  constructor (props) {
    super(props);

    this.today = moment();
  }

  get currentCenterPerimission () {
    return this.props.currentCenterInformation ? this.props.currentCenterInformation.permissions : {};
  }

  get eventsForToday () {
    if (this.props.events) {
      const yearMonthKey = this.today.clone().format('YYYY-MM');

      if (this.props.events[yearMonthKey]) {
        const eventsForMonth = this.props.events[yearMonthKey].events;

        return eventsForMonth.filter(event => moment(event.starts_at).isSame(this.today, 'day'));
      }
    }

    return [];
  }

  get menusForToday () {
    if (this.props.menus) {
      return this.props.menus.filter(menu => moment.utc(menu.menuDate).isSame(this.today, 'day'));
    }

    return [];
  }

  showMenusCard = () => {
    return this.menusForToday.length > 0 && this.currentCenterPerimission.admin;
  }

  showEventsCard = () => {
    return this.currentCenterPerimission.admin || this.currentCenterPerimission.calendar;
  }

  render () {
    return (
      <div className='day-overview-container'>
        { this.showMenusCard() && <TodaysMenu isLoading={this.props.fetchingMenus && this.menusForToday.length === 0} menu={this.menusForToday[0]} /> }
        { this.showEventsCard() && <TodaysEvents isLoading={this.props.fetchingEvents && this.eventsForToday.length === 0} events={this.eventsForToday} /> }
      </div>
    );
  }
}

function mapStateToProps (state, ownProps) {
  return {
    events: state.events.byMonth,
    menus: state.menus.info.menus,
    currentCenterInformation: state.identity.centers.filter(center => parseInt(center.id, 10) === parseInt(state.identity.centerId, 10))[0],
    fetchingEvents: state.events.meta.fetchingEvents,
    fetchingMenus: state.menus.info.fetchingMenus
  };
}

function mapDispatchToProps (dispatch) {
  return {

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DayOverview);
